import React from 'react';
import { customerInfoHandler, formatIndianCurrency, handleNavigate, saveLogEvent } from '../../utils/Utils';
import { useNavigate } from 'react-router-dom';

const GroupSummary = ({ customerInfo, labels }) => {
    const navigate = useNavigate();
    const stat = customerInfoHandler(customerInfo);

    const onCliclHandler = () => {
        saveLogEvent(
            {
                logLevel: "info",
                statusCode: 200,
                status: "success",
                source: "MCRO",
                message: { trigger: "On click of button Pay For a Group Member", GroupNumber: stat.groupNumber, Page: "Home Page" },
                payload: {
                    trigger: "On click of button Pay For a Group Member",
                    Page: "Home Page"
                }

            },

        );
        handleNavigate(navigate, "/customerDetails")
    }

    return (
        <>
            <div className="flex font-bold mt-6 text-black text-lg border-t border-r border-l bg-gray-300 p-3 rounded-t-[15px] fs-32w">
                {labels.yourGroup}: {stat.groupName} ( {stat.groupNumber} )
            </div>

            <div className={`${stat.overdueMember !== 0 ? 'bg-red-500 text-white' : 'bg-green-200 text-black'} p-4 rounded-tl-none rounded-tr-none rounded-b-[15px] fs-30w`}>
                <div className="grid grid-cols-2 gap-2">
                    <div>{labels.health}</div>
                    <div className="justify-self-end">{stat.healthStatus}</div>
                    <div>{labels.activeMembers}</div>
                    <div className="justify-self-end">{stat.memberCount}</div>
                    <div>{labels.overdueMembers}</div>
                    <div className="justify-self-end">{stat.overdueMember}</div>
                    <div>{labels.overdue}</div>
                    <div className="justify-self-end">{formatIndianCurrency(stat.overdueAmount)}</div>
                </div>
                <div className="flex justify-center">
                    <button
                        onClick={() => onCliclHandler()}
                        className={`${stat.overdueMember !== 0 ? " text-red-800" : "text-green-800"} mt-4 bg-white px-4 py-2 rounded-lg`}
                    >
                        {labels.payForGroupMember}
                    </button>
                </div>
            </div>
        </>
    );
}

export default GroupSummary;
